import { LooseAutocomplete } from '@b2b/types/core/utils';

/**
 * Concat an array and validates the values exist
 */
export function arrayConcat(words: string[], glue: string) {
  return words.filter((word) => !!word).join(glue);
}

export function getFullName(
  data: Partial<{ firstName: string | null; lastName: string | null; name: string; email: string }> | null = {},
) {
  if (data == null) {
    return '';
  }

  if (data.firstName != null && data.firstName !== '' && data.lastName != null && data.lastName !== '') {
    return `${data.firstName} ${data.lastName}`;
  }

  if (data.name != null && data.name !== '') {
    return data.name;
  }

  if (data.email != null && data.email !== '') {
    return data.email;
  }

  return '';
}

/**
 * Capitalize
 */
export function cap(value: string) {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
}

/**
 * lowCapitalize
 */
export function low(string: string) {
  return string ? string.charAt(0).toLowerCase() + string.slice(1) : '';
}

const fieldTypes = ['NumberType', 'NumberArrayType', 'StringType', 'StringArrayType', 'RangeType'] as const;

export type CustomFieldType = LooseAutocomplete<(typeof fieldTypes)[number]>;
export interface CustomFieldDefinition {
  fieldOrder: number;
  name: string;
  type: CustomFieldType;
  stringValue: string;
  stringArrayValue: string[];
  minValue: number;
  maxValue: number;
  hidden: boolean;
}

/**
 * Removes non-selected type value from field
 */
export function clearFieldValues(field: CustomFieldDefinition) {
  for (let i = 0, ii = fieldTypes[i].length; i < ii; i++) {
    if (field.type && field.type !== fieldTypes[i]) {
      const fieldKey = low(field.type.replace('Type', 'Value'));
      field[fieldKey] = null;
    }
  }

  return field;
}
